  // Generate thumbnail from the video element after it loads
export const createVideoThumbnail = async (videoUrl, percent = 10) => {
  return new Promise((resolve, reject) => {
    try {
      const video = document.createElement('video');
      video.crossOrigin = 'anonymous';
      video.preload = 'metadata';
      video.muted = true;
      video.playsInline = true;
      video.src = videoUrl;

      const onError = (e) => reject(e instanceof Event ? new Error('Failed to load video') : e);

      video.addEventListener('error', onError, { once: true });

      video.addEventListener('loadedmetadata', () => {
        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        const clampedPercent = Math.min(100, Math.max(0, percent));
        let seekTo = 0;
        if (duration > 0) {
          seekTo = (duration * clampedPercent) / 100;
        } else {
          seekTo = 1; // fallback seek when duration is unknown
        }
        try {
          video.currentTime = seekTo;
        } catch (_) {
          video.currentTime = 0;
        }
      }, { once: true });

      video.addEventListener('seeked', () => {
        try {
          const canvas = document.createElement('canvas');
          const width = video.videoWidth || 320;
          const height = video.videoHeight || 180;
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, width, height);
          const imageUrl = canvas.toDataURL('image/png');
          resolve(imageUrl);
        } catch (err) {
          reject(err);
        }
      }, { once: true });
    } catch (err) {
      reject(err);
    }
  });
};
